import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import "swagger-ui-react/swagger-ui.css"
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './auth0/Auth0ProviderWithNavigate/Auth0ProviderWithNavigate'

// Suppress "canceled" errors from React Strict Mode in development
// These occur when requests are aborted due to component unmount/remount
if (process.env.NODE_ENV === 'development') {
    // Suppress from console
    const originalError = console.error;
    console.error = (...args) => {
        if (args[0]?.includes?.('CanceledError') || args[0]?.message === 'canceled') {
            return;
        }
        originalError.apply(console, args);
    };

    // Suppress from error overlay
    window.addEventListener('error', (event) => {
        if (event.message?.includes('canceled') || event.error?.message === 'canceled') {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    });

    window.addEventListener('unhandledrejection', (event) => {
        if (event.reason?.message === 'canceled' || event.reason?.code === 'ERR_CANCELED') {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    });
}

const container = document.getElementById('root');
const root = createRoot(container);

// Disable StrictMode for local Docker development to prevent double-render API issues
const StrictModeWrapper = process.env.REACT_APP_DISABLE_STRICT_MODE === 'true'
    ? React.Fragment
    : React.StrictMode;

root.render(
    <StrictModeWrapper>
        <BrowserRouter>
            <Auth0ProviderWithNavigate>
                <App />
            </Auth0ProviderWithNavigate>
        </BrowserRouter>
    </StrictModeWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
